import React from "react";

import * as SC from './CorrectionModeButtons.styled';
import useOneClickStore, { OneClickStore } from "../../Hooks/useOneClickStore";
import { RoundedCornersButton } from "../Buttons";

interface Props {
    handleOneClickButton: () => void;
    handleClassicButton: () => void;
}

export const CorrectionModeButtons: React.FC<Props> = ({
    handleClassicButton,
    handleOneClickButton,
}) => {
    const isOneClickModeActive = useOneClickStore((store: OneClickStore) => store.isOneClickModeActive);

    return (
        <SC.ChangeEditorWrapper>
            <RoundedCornersButton
                className={!isOneClickModeActive ? "active" : ""}
                onClick={handleClassicButton}
            >
                Mentor Standard
            </RoundedCornersButton>
            <RoundedCornersButton
                className={isOneClickModeActive ? "active" : ""}
                onClick={handleOneClickButton}
            >
                Mentor Express <sup>BETA</sup>
            </RoundedCornersButton>
        </SC.ChangeEditorWrapper>
    );
};
